import { render, staticRenderFns } from "./Styling.vue?vue&type=template&id=bf203004"
import script from "./Styling.vue?vue&type=script&lang=js"
export * from "./Styling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports